import React from 'react';
import PropTypes from 'prop-types';
import "./TopBar.css";

const TopBar = ({ userEmail, handleSignOut }) => {
  return (
    <div className="mainTopBar">
      <p style={{ fontSize: "0.85rem", opacity: 0.7 }}>
        {userEmail}
      </p>
      <button
        onClick={handleSignOut}
        className="mainBtn signOutBtn signOutBtnSmall"
      >
        Sign out
        <span role="img" aria-label="Peace emoji">
          ✌️
        </span>
      </button>
    </div>
  );
};

TopBar.propTypes = {
  userEmail: PropTypes.string.isRequired,
  handleSignOut: PropTypes.func.isRequired,
};

TopBar.displayName = 'TopBar';

export default React.memo(TopBar);
